import { render, staticRenderFns } from "./board_new2.vue?vue&type=template&id=069895f6&scoped=true&"
import script from "./board_new2.vue?vue&type=script&lang=js&"
export * from "./board_new2.vue?vue&type=script&lang=js&"
import style0 from "./board_new2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./board_new2.vue?vue&type=style&index=1&id=069895f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069895f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
